const myTransactions = {
  selectDateRage:'Seleccionar rango de fechas',
  selectTransactionType:'Seleccionar tipo de transacción',
  selectApplication:'Seleccionar aplicación',
  export:'Exportar',
};

export default myTransactions;
